import { render, staticRenderFns } from "./otherPage.vue?vue&type=template&id=1857efc6&scoped=true&"
import script from "./otherPage.vue?vue&type=script&lang=js&"
export * from "./otherPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1857efc6",
  null
  
)

export default component.exports